import Settings from '../../../../../settings/Settings';

const LABEL = {
    FONT: Settings.FONTS.LXGW_CYRILLIC_BOLD,
    SIZE: 60,
    TINT: 0xffffff,
    SHADOW: { OFFSET: 4, TINT: 0x000000, ALPHA: 0.5 },
};

export default class Title extends Phaser.GameObjects.Container {
    private bg!: Phaser.GameObjects.Image;
    private label!: Phaser.GameObjects.BitmapText;

    constructor(scene: Phaser.Scene, x: number, y: number, title: string) {
        super(scene, x, y);

        this.setupBG();
        this.setupLabel(title);
    }

    private setupBG(): void {
        const frame = 'gui/common/popup_core/bg_title';

        this.bg = this.scene.add.image(0, 0, 'atlas', frame);
        this.bg.setOrigin(0.5, 0);
        this.add(this.bg);
    }

    private setupLabel(titleKey: string): void {
        const x = 0;
        const y = this.bg.displayHeight / 2 - 5;

        this.label = this.scene.add.bitmapText(x, y, LABEL.FONT, this.scene.cache.json.get('i18n')[titleKey] , LABEL.SIZE);
        this.label.setOrigin(0.5);
        this.label.setTint(LABEL.TINT);
        this.label.setDropShadow(LABEL.SHADOW.OFFSET, LABEL.SHADOW.OFFSET, LABEL.SHADOW.TINT, LABEL.SHADOW.ALPHA);
        this.add(this.label);
    }

    public get totalWidth(): number {
        return this.bg.displayWidth;
    }

    public get totalHeight(): number {
        return this.bg.displayHeight;
    }
}
